/**
 * NOTE: 	this component is one of the first base form fields and is a good example how not to structure a component.
 * 			event binding should be done by events, the attach logic should be done in the prepare method, includes should be done in ejs, ...
 */

const utils = require('../../../lib/utils');

// TODO: periodEnd submits wrong times (timezones and other problems)

module.exports = {
	config: {
		deltaStartYears:    -5,
		deltaEndYears:      10
	},

	model: {
		dataDATE: ''       // ISO-8601
	},

	date: null, // Date Object

	$fields: {
		day: null,
		month: null,
		year: null
	},

	methods: {
		/**
		 * this function is used to set the actual date according to a given day, month and or year.
		 * it is possible to define all parameters or just a single one.
		 * furthermore,  this function will set the model value and tell the parent form the new value.
		 *
		 * NOTE: max day problems of months and their correlating years will be handled properly. 31.1.2016 => Month to Feb. => 29.2.2016
		 *
		 * @param day           int - day [D]
		 * @param month         int - month (starting at zero) [MM]
		 * @param year          int - year [YYYY]
		 */
		setDate: function(day, month, year){
			// estimate all params if they are given partially
			if(day === undefined)   day = this.date.getDate();
			if(month === undefined) month = this.date.getMonth();
			if(year === undefined)  year = this.date.getFullYear();

			// estimate max nr of days in actual month
			this.date.setDate(1);
			this.date.setMonth(month + 1);
			this.date.setFullYear(year);
			this.date.setDate(0);
			var maxDaysInMonth = this.date.getDate();

			// set real month and year
			this.date.setMonth(month);
			this.date.setFullYear(year);

			// set date according to max nr of days in actual month
			var $day = this.$.find('[name="day"]');
			if(day > maxDaysInMonth){
				$day.val(maxDaysInMonth);
				this.date.setDate(maxDaysInMonth);
			}
			// set real day if maxDaysInMonth has not been reached
			else {
				this.date.setDate(day);
			}

			// set visible state of days in select box according to max nr of days in actual month
			$day.find('option').each(function(index){
				if(index < maxDaysInMonth)  $(this).show();
				else                        $(this).hide();
			});

			// update input fields
			if(this.$fields.day) 	this.$fields.day.val(day)
			if(this.$fields.month) 	this.$fields.month.val(month + 1)
			if(this.$fields.year) 	this.$fields.year.val(year)

			// set model value
			this.model.dataDATE = this.date.toISOString();

			// tell parent form that this field has been changed
			this.parent(function(parentComponent){
				parentComponent.trigger('onChildChanged', {
					fieldCode: this.model.fieldCode,
					value: this.model.dataDATE
				});
			});
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;

			// init date field
			if(utils.isEmpty(this.model.dataDATE)){
				var newDate = new Date();
				newDate.setHours(0, 0, 0, 0);
				this.model.dataDATE = newDate.toISOString();
			}
			this.date = new Date(this.model.dataDATE);

			// create fields if they does not exist
			if(utils.isEmpty(this.$fields.day)){
				var days = [];
				for(var day = 1; day < 32; day++){
					days.push({
						name: day,
						value: day
					});
				}
				this.$fields.day = $(self.include('select', { model: {
					dataJSON: [self.date.getDate()],
					fieldCode: 'day',
					data: {
						options: days
					}
				}}));

				this.$fields.month = $(self.include('select', { model: {
					dataJSON: [self.date.getMonth() + 1],
					fieldCode: 'month',
					data: {
						options: [
							{value: 1, lang: {'de-at': {name: 'Jänner'}, 'en-gb': {name: 'January'}}},
							{value: 2, lang: {'de-at': {name: 'Februar'}, 'en-gb': {name: 'February'}}},
							{value: 3, lang: {'de-at': {name: 'März'}, 'en-gb': {name: 'March'}}},
							{value: 4, lang: {'de-at': {name: 'April'}, 'en-gb': {name: 'April'}}},
							{value: 5, lang: {'de-at': {name: 'Mai'}, 'en-gb': {name: 'May'}}},
							{value: 6, lang: {'de-at': {name: 'Juni'}, 'en-gb': {name: 'June'}}},
							{value: 7, lang: {'de-at': {name: 'Juli'}, 'en-gb': {name: 'July'}}},
							{value: 8, lang: {'de-at': {name: 'August'}, 'en-gb': {name: 'August'}}},
							{value: 9, lang: {'de-at': {name: 'September'}, 'en-gb': {name: 'September'}}},
							{value: 10, lang: {'de-at': {name: 'Oktober'}, 'en-gb': {name: 'October'}}},
							{value: 11, lang: {'de-at': {name: 'November'}, 'en-gb': {name: 'November'}}},
							{value: 12, lang: {'de-at': {name: 'Dezember'}, 'en-gb': {name: 'December'}}}
						]
					}
				}}));

				var years = [];
				var year = new Date().getFullYear();
				for(y = (year + this.config.deltaStartYears); y <= (year + this.config.deltaEndYears); y++){
					years.push({
						name: y,
						value: y
					});
				}
				this.$fields.year = $(self.include('select', { model: {
					dataJSON: [self.date.getFullYear()],
					fieldCode: 'year',
					data: {
						options: years
					}
				}}));
			}

			// bind field events and set their actual date
			this.$fields.day.change(function(event){
				event.stopImmediatePropagation();
				var target = event.originalEvent ? event.originalEvent.target : event.target;
				self.setDate(target.value);
			});
			this.$fields.month.change(function(event){
				event.stopImmediatePropagation();
				var target = event.originalEvent ? event.originalEvent.target : event.target;
				self.setDate(undefined, target.value - 1);
			});
			this.$fields.year.change(function(event){
				event.stopImmediatePropagation();
				var target = event.originalEvent ? event.originalEvent.target : event.target;
				self.setDate(undefined, undefined, target.value);
			});

			var $foundField;
			for(var fieldName in this.$fields){
				$foundField = $element.find('[name="' + fieldName + '"]');
				if($foundField.length > 0)  $foundField.replaceWidth(this.$fields[fieldName]);
				else                        $element.append(this.$fields[fieldName]);
			}
		}
	}
};
